'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwLabel = require('./CwLabel.scss');

var _CwLabel2 = _interopRequireDefault(_CwLabel);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwLabel = function CwLabel(props) {
  if (props.isHTML) {
    var _cx;

    return _react2.default.createElement('label', {
      'data-cwid': props.cwId,
      htmlFor: props.htmlFor,
      style: props.style,
      tabIndex: props.isLink ? 0 : undefined,
      className: (0, _classnames2.default)(props.className, (_cx = {}, (0, _defineProperty3.default)(_cx, _CwLabel2.default.underline, props.underline), (0, _defineProperty3.default)(_cx, _CwLabel2.default.clickable, props.onClick), (0, _defineProperty3.default)(_cx, _CwLabel2.default.bold, props.bold), (0, _defineProperty3.default)(_cx, _CwLabel2.default.italic, props.italic), (0, _defineProperty3.default)(_cx, _CwLabel2.default.podLabel, props.isPodLabel), (0, _defineProperty3.default)(_cx, _CwLabel2.default.disabled, props.disabled), (0, _defineProperty3.default)(_cx, _CwLabel2.default.invalid, props.invalid), (0, _defineProperty3.default)(_cx, _CwLabel2.default.link, props.isLink), (0, _defineProperty3.default)(_cx, _CwLabel2.default.grey1, props.grey1), (0, _defineProperty3.default)(_cx, _CwLabel2.default.grey2, props.grey2), (0, _defineProperty3.default)(_cx, _CwLabel2.default.grey3, props.grey3), (0, _defineProperty3.default)(_cx, _CwLabel2.default.grey4, props.grey4), (0, _defineProperty3.default)(_cx, _CwLabel2.default.grey5, props.grey5), _cx)),
      onClick: props.onClick,
      onFocus: props.onFocus,
      onBlur: props.onBlur,
      dangerouslySetInnerHTML: { __html: props.value } });
  } else {
    var _cx2;

    return _react2.default.createElement(
      'label',
      {
        'data-cwid': props.cwId,
        htmlFor: props.htmlFor,
        style: props.style,
        tabIndex: props.isLink ? 0 : undefined,
        className: (0, _classnames2.default)(props.className, (_cx2 = {}, (0, _defineProperty3.default)(_cx2, _CwLabel2.default.underline, props.underline), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.clickable, props.onClick), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.bold, props.bold), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.italic, props.italic), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.podLabel, props.isPodLabel), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.disabled, props.disabled), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.invalid, props.invalid), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.link, props.isLink), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.grey1, props.grey1), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.grey2, props.grey2), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.grey3, props.grey3), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.grey4, props.grey4), (0, _defineProperty3.default)(_cx2, _CwLabel2.default.grey5, props.grey5), _cx2)),
        onClick: props.onClick,
        onFocus: props.onFocus,
        onBlur: props.onBlur },
      props.isHTML ? null : props.value,
      props.isHTML ? null : props.children
    );
  }
};

CwLabel.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes2.default.string,
  /**
   * Value of label must be strings
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /**
   * True to set innerHTML directly.
   * Make sure not to expose users to XSS attack
   */
  isHTML: _propTypes2.default.bool,
  /**
   * Children of label must be strings
   */
  children: _propTypes2.default.string,
  /**
   * Id of the element this label is for
   */
  htmlFor: _propTypes2.default.string,
  /**
   * Allows custom styling
   */
  style: _propTypes2.default.object,
  /**
   * Used for adding extra css
   */
  className: _propTypes2.default.string,
  /**
   * Callback function fired when label is clicked
   */
  onClick: _propTypes2.default.func,
  /**
   * Controls if label is underlined
   */
  underline: _propTypes2.default.bool,
  /**
   * Controls if label is bold
   */
  bold: _propTypes2.default.bool,
  /**
   * Controls if label is in italics
   */
  italic: _propTypes2.default.bool,
  /**
   * Controls if label should have same styling as CwPodElement's label
   */
  isPodLabel: _propTypes2.default.bool,
  /**
   * Controls if label should be styled as a link button
   */
  isLink: _propTypes2.default.bool,
  /**
   * Controls if label is disabled, gets disabled styling
   */
  disabled: _propTypes2.default.bool,
  /**
   * Controls if label is invalid, gets invalid styling
   */
  invalid: _propTypes2.default.bool,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes2.default.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes2.default.func,
  /**
   * Gray scale colors
   */
  grey1: _propTypes2.default.bool,
  grey2: _propTypes2.default.bool,
  grey3: _propTypes2.default.bool,
  grey4: _propTypes2.default.bool,
  grey5: _propTypes2.default.bool
};

exports.default = CwLabel;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwlabel/CwLabel.js
// module id = 37
// module chunks = 10